export function getInitials(name: string) {
  if (!name) return "";

  return name
    .split(" ")
    .slice(0, 2)
    .map((a) => a.charAt(0))
    .join("")
    .toUpperCase();
}
